<template>
  <div class="container">
    <div id="page-div" class="container interline" ref="document">
      <div id="page1-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12 text-center">
            <span class="ft15Black"> <br />GPI AUTO COMERCIAL</span>
          </div>
          <div class="col-12 text-center">
            <span class="ft7Gray">
              <br />Av. De las Rosas 2991, Colonia. Chapalita, C.P. 44510,
              Guadalajara, Jalisco.<br />
            </span>
          </div>
          <div class="col-12 text-justify">
            <span class="ft13Black ">
              <br />CONTRATO NÚMERO:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.No_Operacion_Cliente }}
              </span>
              <br /><br />
            </span>
          </div>
          <div class="col-12 text-center mt-3  bg-info">
            <span class="ft13Black text-white"><br />
              CARATULA<br />
            </span>
            <div class="col-12 text-justify bg-info p-2">
              <span class="ft12Black text-white">
                ARRENDADOR
              </span>
            </div>
          </div>
          <div class="col-12  border border-dark">
            <span class="ft13 ">
              <br />Nombre:
              <span class="ft13Black">
                GPI AUTO COMERCIAL SAPI DE C.V.
              </span>
              RFC:
              <span class="ft13Black">
                GAC150505Q30
              </span>
              &
              <br />
              Domicilio:
              <span class="ft13Black">
                Av. De las Rosas 2991, Colonia Chapalita, C.P. 44510,
                Guadalajara,
              </span>
              <br />Representante Legal:
              <span class="ft13Black"> Jesús Fernández Morán</span>
              <br />1.- Escritura Pública número 9,195 de fecha 23 de Marzo de
              2015, otorgada ante la fe del Licenciado Rodolfo Ramos Menchaca
              Notario Pública Titular número 117 de Guadalajara, Jalisco,
              debidamente Inscrita bajo INSCRIPCION 90932- 1 del Registro
              Público de Comercio en la ciudad d Guadalajara, Jalisco, en la que
              se hizo constar la constitución de la Sociedad, con fecha de
              inscripción del 12 de Agosto del 2015 Tomo de escritura XLVI del
              libro Siete.<br />
              2.-Escritura Pública número 37,563 Tomo CCCXLIV, Libro NOVENO
              Poder Con facultades generales de Fecha 4 de Noviembre del 2021,
              otorgad ante la fe del Lic. Guillermo Coronado Figueroa Notario
              Público Titular número 50 de Guadalajara, Jalisco.
              <br /><br />
            </span>
          </div>
          <div class="col-12  bg-info p-2">
            <span class="ft11Black text-white"> ARRENDATARIA </span>
          </div>
          <div class="col-12 border border-dark">
            <span class="ft13">
              Nombre:<span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.nombre_cliente }}
              </span>
              RFC:<span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.RFC }} </span>.
              <br />
              Domicilio: CALLE
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.calle_cliente }}</span>
              No.
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_calle_cliente }}   {{ data.numero_calle_int_cliente }}</span>
              COLONIA
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.colonia_cliente }},
              </span>
              CODIGO POSTAL
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.codigo_postal_cliente }}, </span>DE LA POBLACION DE
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.municipio_cliente }}, </span>MUNICIPIO DE
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.municipio_cliente }}, </span><span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.estado_cliente }}. </span>
              <span v-if="data.tipoAmoral">
                <br />
                Representante Legal:
                <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.reprecentante_legal }}.
                </span>
              </span>
              <br />
              <br /></span>
          </div>
          <div v-if="data.tipoAendorsement || data.tipoAbound">
            <div class="col-12  bg-info p-2" v-if="data.tipoAendorsement">
              <span class="ft11Black text-white" v-if="data.tipoAendorsement">
                DEUDOR SOLIDARIO y AVAL<br />
              </span>
            </div>

            <div class="col-12 border border border-dark" v-if="data.tipoAendorsement">
              Nombre:
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.nombre_aval }}</span>
              RFC:
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.RFC_aval }}</span><br />
              Domicilio: CALLE
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.calle_aval }}</span>
              No.
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.numero_calle_aval }}</span>
              COLONIA
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.colonia_aval }},
              </span>
              CODIGO POSTAL
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.codigo_postal_aval }}, </span>DE LA POBLACION DE
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.municipio_aval }}, </span>MUNICIPIO DE
              <span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.municipio_aval }}, </span><span class="ft11Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.estado_aval }}. </span>.<br />
            </div>
            <div class="col-12  bg-info p-2" v-if="data.tipoAbound">
              <span class="ft11Black text-white" v-if="data.tipoAbound">
                DEUDOR SOLIDARIO y AVAL<br />
              </span>
            </div>
            <div class="col-12 border border-dark" v-if="data.tipoAbound">
              Nombre:
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.nombre_obligado }}</span>
              RFC:
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.RFC_Obligado }}</span><br />
              Domicilio: CALLE
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.calle_obligado }}</span>
              No.
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.numero_calle_obligado }}</span>
              COLONIA
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.colonia_obligado }},
              </span>
              CODIGO POSTAL
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.codigo_postal_obligado }}, </span>DE LA POBLACION DE
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.municipio_obligado }}, </span>MUNICIPIO DE
              <span class="ft11Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.municipio_obligado }}, </span><span class="ft11Black"
                v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.estado_obligado }}.
              </span><br />
            </div>
          </div>

          <div class="col-12  bg-info p-2">
            <span class="ft11Black text-white"> DATOS DEL VEHÍCULO<br /> </span>
          </div>
          <div class="col-12 border border-dark">
            <span class="ft13">
              Marca:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.marca_vehiculo }}
              </span>
              Modelo/Tipo de Vehículo:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.modelo_vehiculo }}
              </span>
              Año:<span v-bind:class="{ marca: data.showMarca }" class="ft11Black">
                {{ data.año_vehiculo }},
              </span>
              Número de Serie:<span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_serie_vehiculo.toUpperCase() }}
              </span>
              Numero de Motor:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_motor_vehiculo.toUpperCase() }}
              </span>
              <br /> </span><br />
          </div>
          <div class="col-12  bg-info p-2 border-dark">
            <span class="ft11Black text-white"> PAGO INICIAL<br /> </span>
          </div>
          <div class="col-12 border border-dark">
            <span class="ft13">
              comision por apertura:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                ${{ data.comision_apertura }}
              </span>
              <br />
              Gastos administrativos:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                ${{ data.enganche }}
              </span>
              <br />
              Renta Corriente:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                ${{ data.mensualidad }}
              </span>
              <br />
            </span>
          </div>
          <div class="col-12  bg-info p-2 border-dark">
            <span class="ft11Black text-white">SUS PAGOS SERÁN COMO SIGUE:</span>
          </div>
          <div class="col-12 border border-dark">
            <span class="ft13">
              Plazo:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.plazo }}
              </span>
              <br />
              Fecha primer pago:
              <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.fecha_primer_pago }}
              </span>
              <br />
              <br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              1
            </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "ContatoPrenda",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/views/contratoArrendamiento/CaraturaArrendamiento.vue